import { fromJS } from 'immutable'
import {
  COMPANY_EDIT_REQUEST,
  COMPANY_EDIT_SUCCESS,
  COMPANY_EDIT_FAILURE,
  COMPANY_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPANY_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case COMPANY_EDIT_SUCCESS:
      return state
        .set('companyEdit', fromJS(action.payload.updatedCompany))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case COMPANY_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('companyEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case COMPANY_EDIT_RESET:
      return state
        .delete('companyEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company/company-edit-reducer.js